export default __webpack_public_path__ + "static/Roboto-Regular-1ba679c05036b34bf359aa2e6c450faa.ttf";